import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { IPaginacao } from "src/app/shared/interface/paginacao.interface";
import { CodigoTransacaoService } from "src/app/shared/services/codigo-transacao.service";
import { ExcelService } from "src/app/shared/services/excel.service";
import { RBACService } from "src/app/shared/services/rbac.service";
import { generateUUID } from "src/app/shared/utils/functions/codigo-transacao.model";
import { showError } from "src/app/shared/utils/functions/notification.function";
import { safeAsign } from "src/app/shared/utils/functions/safe-asign.function";
import Swal from "sweetalert2";

import {
  IDecendio,
  IInstituicao,
  IPosicoes,
} from "../../interface/relatorio-pagamento.interface";
import { RelatorioPagamentoDecendialService } from "../../services/relatorio-pagamento-decendial.service";
import { encryptStorage } from "src/app/shared/utils/storage/storage";
import { IResult } from "src/app/shared/interface/result.interface";

@Component({
  selector: "app-relatorio-pagamento-decendial",
  templateUrl: "./relatorio-pagamento-decendial.component.html",
  styleUrls: [
    "./relatorio-pagamento-decendial.component.scss",
    "../../../shared/styles/default.scss",
  ],
})
export class RelatorioPagamentoDecendialComponent implements OnInit {
  query = {
    codigoTransacao: this.codigo.getUniqueId(5),
    instituicao: '',
    corretora: '',
    competencia: '',
    decendio: '',
    investimento: '',
    documentoIdentificador: '',
    codigoTermo: '',
    sortBy: 'instituicao',
    orderBy: 'asc',
    page: 1,
    pageSize: 10000,
  };

  instituicaoInformada: string = '';
  decendioInformado: string = '';
  messageErro: string = '';
  exibir: boolean = false;
  exibirTabela: boolean = false;
  tableData: any[] = [];

  tableInstituicao: IInstituicao[] = [];
  tableDecendio = [];
  paginacaoData: IPaginacao;

  dataComp: string = '';

  progresso = {
  valor: 0,
  exibe: false,
  cancelado: false,
  pausado: false
  }

  tableExcel: any;
  rbacService: RBACService;

  tipoUsuario: string = "";
  constructor(
    private codigo: CodigoTransacaoService,
    private relatorioService: RelatorioPagamentoDecendialService,
    private excelService: ExcelService
  ) {}

  ngOnInit() {
    this.rbacService = new RBACService(encryptStorage.getItem("@rbac", true));
    this.tipoUsuario = String(
      encryptStorage.getItem("@tipoUsuario")
    ).toUpperCase();
    moment().locale("pt-br");
    this.listarInstituicoes();
    this.fillDecendios();
  }

  canSearch(): boolean {
    return !!(this.query.documentoIdentificador || this.query.codigoTermo);
  }

  pesquisar(page) {
    if (safeAsign(this.query.instituicao)) {
      return showError('',
        'Você precisa informar o nome de uma Instituição Financeira para prosseguir.'
      );
    }
    if (safeAsign(this.dataComp)) {
      return showError('',
        'Você precisa inserir uma Data de Pagamento no campo Mês/Ano para prosseguir.'
      );
    }

    if (this.dataComp.length < 6) {
      return showError('',"A 'Competência' informada não é válida.");
    }

    if (safeAsign(this.query.decendio)) {
      return showError('','Você precisa informar o Decêncio para prosseguir.');
    }

    if (safeAsign(this.query.investimento)) {
      return showError('','Você precisa informar o Investimento para prosseguir.');
    }

    this.query.competencia = this.dataComp.split('-').join('').replace("/", "");

    this.query.page = page;
    this.relatorioService.listarRelatorioPagamento(this.query).subscribe(
      (res) => {
        (this.exibir = false), (this.tableData = res['data']);
        this.paginacaoData = res['paginacao'];
      },
      (e) => {
        return showError('', e.error.data.detalhesErro[0]);
      },
      () => {
        if (this.tableData.length == 0) {
          this.messageErro = 'Não foram retornados registros para os filtros informados.';
          this.exibir = true;
          this.exibirTabela = false;
        } else {
          this.exibirTabela = true;
        }
      }
    );
  }

  listarInstituicoes() {
    let query = { codigoTransacao: this.codigo.getUniqueId(4) };
    return (
      this.relatorioService.listarInstituicoes(query).subscribe(
        (res) => {
          this.tableInstituicao = res['data'];
        },
        (e) => {
          console.log(e);
        }
      ),
      () => this.fillDecendios()
    );
  }

  fillDecendios() {
    let params = { codigoTransacao: generateUUID(5) };
    return this.relatorioService.listarDecendios(params).subscribe(
      (res) => (this.tableDecendio = res['data']),
      (e) => console.log(e)
    );
  }

  handleSubAndTotal(page: number, pageSize: number = 10000): Promise<any> {
    let queryTotal = {
      codigoTransacao: this.codigo.getUniqueId(5),
      instituicao: this.query.instituicao,
      corretora: this.query.corretora,
      competencia: this.query.competencia,
      investimento: this.query.investimento,
      decendio: this.query.decendio,
      page: page,
      pageSize: pageSize,
      orderBy: this.query.orderBy,
      sortBy: this.query.sortBy,
      documentoIdentificador: this.query.documentoIdentificador,
      codigoTermo: this.query.codigoTermo,
    };

    return new Promise((resolve, reject) => {
      this.relatorioService.listarExportacao(queryTotal).subscribe(
        (res) => resolve(res),
        (e) => reject(e)
      );
    });
  }

  insereRegistroExcel(dataArray: any[]) {
    if (!dataArray || dataArray.length === 0) return [];

    return dataArray.map((data) => {
      let isCorretora = data.corretora == null ? data.razaoSocialPropio : data.corretora;

      return {
        'Extraido em': `="${data.extraidoEm}"`,
        'Raiz CNPJ': `="${data.instituicao}"`,
        'Razão Social Próprio ou Intermediárias': `="${isCorretora}"`,
        'Início Decêndio': `="${data.inicioDecendio}"`,
        'Fim Decêndio': `="${data.fimDecendio}"`,
        Decêndio: `="${data.decendio}"`,
        Mês: `="${data.mes}"`,
        'Data de Recolhimento': `="${data.dtRecolhimento}"`,
        'Nº de Controle': `="${data.termoCodigoAtivo}"`,
        'CPF / CNPJ': `="${data.documentoIdentificador}"`,
        'Nome/Razão Social Cliente': `="${data.nomeInvestidor}"`,
        'Saldo Total': (data.saldoTotal !== null && data.saldoTotal !== undefined) ? Number(data.saldoTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        'Valor Bloqueado Judicialmente': (data.valorBloqueio !== null && data.valorBloqueio !== undefined) ? Number(data.valorBloqueio).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        'Valor de Cessão ao FGC Limitada a 250 mil': (data.valor250 !== null && data.valor250 !== undefined) ? Number(data.valor250).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        'Valor do IOF': (data.valorIof !== null && data.valorIof !== undefined) ? Number(data.valorIof).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        'Valor do IRRF': (data.valorIRRF !== null && data.valorIRRF !== undefined) ? Number(data.valorIRRF).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        'VR. Liquido a Pagar ao Cedente': (data.valorTotal !== null && data.valorTotal !== undefined) ? Number(data.valorTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        'Saldo Remanescente': (data.saldoRemanescente !== null && data.saldoRemanescente !== undefined) ? Number(data.saldoRemanescente).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        'Data do Pagto ao Credor': `="${data.dtPagamentoCredor}"`,
        'Inserido Após Fim Decêndio': `="${data.posFimDecendio}"`,
        'CPF Espólio': data.cpfFalecido ? `="${data.cpfFalecido}"` : '',
        'Saldo Total Espólio': (data.saldoTotalFalecido !== null && data.saldoTotalFalecido !== undefined) ? Number(data.saldoTotalFalecido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
        'Valor da Cessão ao FGC limitado a 250 mil Espólio': (data.valorCessao250Falecido !== null && data.valorCessao250Falecido !== undefined) ? Number(data.valorCessao250Falecido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
        'IRRF Espólio': (data.valorIRRFFalecido !== null && data.valorIRRFFalecido !== undefined) ? Number(data.valorIRRFFalecido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
        'IOF Espólio': (data.valorIofFalecido !== null && data.valorIofFalecido !== undefined) ? Number(data.valorIofFalecido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
      };
    });

  }

  async exportarExcel() {
    if (safeAsign(this.query.instituicao)) {
      return showError('',
        'Você precisa informar o nome de uma Instituição Financeira para prosseguir.'
      );
    }
    if (safeAsign(this.dataComp)) {
      return showError('',
        'Você precisa inserir uma Data de Pagamento no campo Mês/Ano para prosseguir.'
      );
    }

    if (this.dataComp.length < 6) {
      return showError('',"A 'Competência' informada não é válida.");
    }

    if (safeAsign(this.query.decendio)) {
      return showError('','Você precisa informar o Decêncio para prosseguir.');
    }

    if (safeAsign(this.query.investimento)) {
      return showError('','Você precisa informar o tipo de Investimento para prosseguir.');
    }

    this.query.competencia = this.dataComp.split('-').join('').replace("/", "");
    this.progresso.exibe = true;
    this.progresso.valor = 0;
    this.progresso.cancelado = false;
    this.progresso.pausado = false;

    try {
      const firstRes = await this.handleSubAndTotal(1);
      const totalPages = firstRes?.paginacao?.totalPaginas || 1;

      let allData: any[] = [];

      for (let page = 1; page <= totalPages; page++) {
        while (this.progresso.pausado) {
          await new Promise((resolve) => setTimeout(resolve, 200));
        }

        if (this.progresso.cancelado) {
          this.progresso.exibe = false;
          return;
        }

        const res = await this.handleSubAndTotal(page);

        if (res?.data) {
          const dadosFormatados = this.insereRegistroExcel(res.data);

          for(let item of dadosFormatados) {
            allData.push(item);
          }
        }

        this.updateProgress(page, totalPages);
      }

      if (this.progresso) {
        await new Promise((resolve) => setTimeout(resolve, 800));
      }

      this.progresso.exibe = false;

      if (allData.length === 0) {
        return Swal.fire({
          icon: 'info',
          title: 'Aviso',
          text: 'Não há dados para exportar com os filtros informados.',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }

      const { value: nomeArquivo } = await Swal.fire({
        title: 'Nome do Arquivo',
        input: 'text',
        inputValue: 'Relatório Pagamento Decendial',
        allowOutsideClick: false,
        inputValidator: (value) => {
          if (!value) return 'Você precisa inserir um nome para prosseguir!';
        },
      });

      if (nomeArquivo) {
        this.excelService.exportCsvFIle(allData, nomeArquivo);
        allData = [];
      }
    } catch (e) {
      console.error(e);
      this.progresso.exibe = false;
      showError('','Erro ao gerar relatório.');
    }
  }

  updateProgress(currentPage: number, totalPages: number) {
    this.progresso.valor = Math.round((currentPage / totalPages) * 100);
  }

  async onCancel() {
    this.progresso.pausado = true;
    const confirmCancel = await Swal.fire({
      title: 'Confirme para prosseguir',
      text: 'A exportação do relatório será interrompida. Tem certeza que deseja prosseguir?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    });

    if (confirmCancel.isConfirmed) {
      this.progresso.cancelado = true;
      this.progresso.pausado = false;
      this.progresso.exibe = false;
    } else {
      this.progresso.pausado = false;
    }
  }

  proximaPagina(event) {
    this.pesquisar(event);
  }

  userHasAcessToResource(codeAccess: Number): Boolean {
    return this.rbacService.userHasAcessToResource(codeAccess);
  }

  isCPF(): boolean {
    let cpfCnpj = this.query.documentoIdentificador;

    return cpfCnpj?.length < 12 ? true : false;
  }

  getCpfCnpjMask(): string {
    return this.isCPF() ? 'AAA.AAA.AAA-AAA' : 'AA.AAA.AAA/AAAA-AA';
  }

  onCpfCnpjInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const upper = input.value.toUpperCase();
    const clean = upper.replace(/[^A-Z0-9]/g, '');
    this.query.documentoIdentificador = clean;
    input.value = upper;
  }

  onCpfCnpjPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const pasted = event.clipboardData?.getData('text') ?? '';
    const clean = pasted.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    this.query.documentoIdentificador = clean;

    setTimeout(() => {
      this.query.documentoIdentificador = clean;
    }, 0);
  }

  onCpfCnpjKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const tudoSelecionado =
      input.selectionStart === 0 && input.selectionEnd === input.value.length;

    if (tudoSelecionado && (event.key === 'Delete' || event.key === 'Backspace')) {
      event.preventDefault();
      event.stopPropagation();
      this.query.documentoIdentificador = '';
      input.value = '';

      setTimeout(() => {
        this.query.documentoIdentificador = '';
        input.value = '';
      }, 0);
    }
  }
}
